import templateUrl from './retainer-cancel-modal.html'
import './retainer-cancel-modal.scss'

const CLIENT_REASONS = [
  'I don’t want to do this work anymore',
  'I want to change the retainer terms (price, hours, scope)',
  'I only paused temporarily and plan to restart',
  'My needs have changed, I no longer need ongoing work',
  'I’m not satisfied with the work/results',
  'Communication or responsiveness was not as expected',
  'I don’t have the budget at the moment, might return later',
  'It’s taking too long / not meeting deadlines',
  'I’ve decided to do this in-house or elsewhere',
  'Other (please explain)'
]

const EXPERT_REASONS = [
  'I no longer have the availability to continue',
  'Need to change the retainer terms (price, hours, scope)',
  'Need to pause temporarily and may return',
  'Client no longer needs ongoing work',
  'Client was not satisfied with the work/results',
  'Client mentioned issues with communication or responsiveness',
  'Client doesn’t have the budget right now',
  'Client said it’s taking too long / deadlines not met',
  'Client decided to move the work in-house or elsewhere',
  'Other (please explain)'
]

const RetainerCancelModalComponent = {
  bindings: {},
  templateUrl,
  require: {
    modalCtrl: '^^cdblModal'
  },
  controller: class RetainerCancelModalController {
    constructor (UserService) {
      'ngInject'
      this.UserService = UserService
      this.selectedReason = null
      this.otherText = ''
      this.isProcessing = false
    }

    $onInit () {
      this.isClient = this.UserService.isClient()
      this.reasons = this.isClient ? CLIENT_REASONS : EXPERT_REASONS
    }

    canSubmit () {
      if (this.selectedReason === 'Other (please explain)') {
        return Boolean(this.otherText && this.otherText.trim().length)
      }
      return Boolean(this.selectedReason)
    }

    submit () {
      if (!this.canSubmit()) return
      const reason = this.selectedReason === 'Other (please explain)'
        ? `${this.selectedReason}: ${this.otherText.trim()}`
        : this.selectedReason
      this.modalCtrl.resolve({ retainer_cancelation_reason: reason })
    }

    cancel () {
      this.modalCtrl.close({ canceled: true })
    }
  }
}

export default RetainerCancelModalComponent


